import callApi, { METHOD_TYPE } from '../utils/callApi'
import { ACCOUNT } from '../mutations'

const state = {
  accountId: ''
}

const mutations = {
  [ACCOUNT.ACCOUNT_ID](state, payload) { state.accountId = payload }
}

const actions = {
  getAccountId({ commit }) {
    callApi('/account-id', METHOD_TYPE.GET)
    .then((response) => {
      commit(ACCOUNT.ACCOUNT_ID, response.body.accountId)
    })
    .catch(e => {
      commit(ACCOUNT.ACCOUNT_ID, 'アカウントIDの取得に失敗しました')
      if (e.response == null) {
        alert('アカウントIDの取得に失敗しました。' + '\n' + e.message)
      } else {
        alert('アカウントIDの取得に失敗しました。' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    }
    )
  }
}

export default {state, actions, mutations}



// WEBPACK FOOTER //
// ./src/stores/account.js